export const environment = {
    baseUrl: 'https://investment-backoffice-api.drahim.sa',
    snbcApiBaseUrl: "https://investment-backoffice-api.drahim.sa/snbc-engine",
    drahimApiBaseURL: 'https://api.drahim.sa',
    isSentryEnabled: true,
    sentryEnv: 'production',
    keycloakUrl: 'https://auth.drahim.sa',
    keycloakRealm: 'master',
    keycloakClientId: 'investment-backoffice',
    isPhoneLoginEnabled: false,
    isSellQtyEnabledForAll: false,
    tadawulURL:
        'https://www.saudiexchange.sa/wps/portal/saudiexchange/ourmarkets/funds-market-watch/mutual-funds/!ut/p/z1/lc9NDoIwFATgs3AA06Ha0m0jCKJYSkWxG9OVaaJojPH8EncEf9_uJd8kM8SShtjW3f3B3fy5dcfu31m-Z5KDZgJKJVEEPVurcBMmdFJxsu0DUaQceiW1ohEDDCX2rzxMyTpQFuMlKqTgv-Xx5iS-522fiDiedmQhshyKIg8HYDixD15seIIPJY27ksuprhv4-UgGwQPkM992/p0/IZ7_5A602H80OOMQC0604RU6VD1067=CZ6_5A602H80OOE770QFTO1V1E24R6=NJgetMutualFundsData=/',
};
